import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const useCandidateProfileFeatureFlags = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  return {
    canRequestDoNotContact: checkIfFeatureFlagEnabled(FeatureFlags.RequestDoNotContactFromProfile),
    canRequestDoNotEngage: checkIfFeatureFlagEnabled(FeatureFlags.RequestDoNotEngageFromProfile),
    canUseNavigationControls: checkIfFeatureFlagEnabled(FeatureFlags.ProfileNavigationControls),
    canUseUrgencyVerification: checkIfFeatureFlagEnabled(FeatureFlags.UrgencyVerification),
    isAddDailyPlanTaskEnabled: checkIfFeatureFlagEnabled(FeatureFlags.DailyPlanAddTaskFromProfile)
  };
};
